import React from "react";
import PropTypes from "prop-types";

// components + styles:
import SrOnly from "core/SrOnly";
import BodyText from "core/BodyText";

const getLabelOrText = ({ text, ariaLabel }) =>
    !ariaLabel || ariaLabel === text ? text : ariaLabel;

const ButtonContent = ({ option }) => {
    const Image = option.img && option.img;

    const conditionalImageProps = option.fillColor && {
        fillColor: option.fillColor
    };

    // if arialabel and its the same as text, give it the text, else label.
    const ariaLabelOrText = getLabelOrText({
        text: option.text,
        ariaLabel: option.ariaLabel
    });

    return option.img ? (
        <>
            <SrOnly>{ariaLabelOrText}</SrOnly>
            <Image
                style={{ height: "1.5rem", width: "auto" }}
                alt=""
                {...conditionalImageProps}
            />
        </>
    ) : (
        <>
            {/* if arialabel & doesnt match text, display both: */}
            {option.ariaLabel && option.ariaLabel !== option.text ? (
                <>
                    {/* show arialabel to screen readers but hide in ui: */}
                    <SrOnly>{option.ariaLabel}</SrOnly>

                    {/* hide text from screen readers but show in ui: */}
                    <BodyText size="md" aria-hidden={true}>
                        {option.text}
                    </BodyText>
                </>
            ) : (
                // if no arialabel, show text:
                <BodyText size="md">{option.text}</BodyText>
            )}
        </>
    );
};

ButtonContent.propTypes = {
    option: PropTypes.object.isRequired
};

export default ButtonContent;
